import { CarouselSectionTypes, CarouselTiledCards } from '@dfh-corp-sites/ui'
import React, { useMemo, useState } from 'react'

import { CarouselSectionProps, SanityImageCarouselSlide } from './types'
import { transformImageSlide } from './utils'

function CarouselSectionImageSimple({
  imageCarouselDeck,
  title,
  subtitle,
  text,
}: Pick<CarouselSectionProps, 'imageCarouselDeck' | 'title' | 'subtitle' | 'text'>) {
  const [activeSlide, setActiveSlide] = useState(0)

  const slides = useMemo(() => {
    if (!imageCarouselDeck?.imageSlides?.length) {
      return []
    }

    return imageCarouselDeck.imageSlides
      .filter((slide): slide is SanityImageCarouselSlide => slide !== null)
      .map((slide, index) =>
        transformImageSlide({
          ...slide,
          _key: slide._key ?? String(index),
          type: slide.type ?? CarouselSectionTypes.Image,
        }),
      )
  }, [imageCarouselDeck])

  if (slides.length === 0) {
    return null
  }

  return (
    <section className="w-full">
      <CarouselTiledCards
        slides={slides}
        sliderType={CarouselSectionTypes.Image}
        title={title}
        subtitle={subtitle}
        text={text}
        activeSlide={activeSlide}
        onSlideChange={(swiper: { realIndex: number }) => setActiveSlide(swiper.realIndex)}
      />
    </section>
  )
}

export default CarouselSectionImageSimple
